/* revoq-eu-withdrawal-hide-branding-v1 */
(function(){
  if (!/\/pages\/eu-withdrawal-form\/?$/.test(window.location.pathname)) return;
  function hideBranding(root){
    if (!root) return;
    root.querySelectorAll('.widerruf-form-branding').forEach(function(el){
      el.style.setProperty('display','none','important');
      el.setAttribute('aria-hidden','true');
    });
    root.querySelectorAll('a,div,span,p,footer').forEach(function(el){
      var txt=(el.textContent||'').replace(/\s+/g,' ').trim();
      var isLeafBranding = /Powered by Revoq|EU Withdrawal Button|Revoq-Logo/i.test(txt) && el.querySelectorAll('input,button,form,[data-widerruf-step]').length === 0 && txt.length < 120;
      if (isLeafBranding) {
        el.style.setProperty('display','none','important');
        el.setAttribute('aria-hidden','true');
      }
    });
  }
  function run(){
    var host = document.querySelector('[data-widerruf-inline]');
    var root = host && host.shadowRoot;
    if (!root) return false;
    hideBranding(root);
    if (!root.__revoqBrandingHideObserver) {
      root.__revoqBrandingHideObserver = new MutationObserver(function(){
        window.clearTimeout(root.__revoqBrandingHideTimer);
        root.__revoqBrandingHideTimer = window.setTimeout(function(){ hideBranding(root); }, 50);
      });
      root.__revoqBrandingHideObserver.observe(root, {childList:true, subtree:true});
    }
    return true;
  }
  var tries = 0;
  var timer = setInterval(function(){ if (run() || ++tries > 60) clearInterval(timer); }, 250);
  document.addEventListener('DOMContentLoaded', run);
})();
/* /revoq-eu-withdrawal-hide-branding-v1 */

/* marche-lino-withdrawal-form-english-v1 */
(function(){
  if (!/\/pages\/eu-withdrawal-form\/?$/.test(window.location.pathname)) return;

  var textMap = {
    'Formulaire de rétractation': 'Withdrawal form',
    '1 · Coordonnées': '1 · Details',
    '2 · Articles': '2 · Items',
    '3 · Confirmé': '3 · Confirmed',
    'Vos coordonnées': 'Your details',
    'Entrez votre e-mail et le numéro de commande. Le vendeur utilise ces données pour l’association manuelle.': 'Please enter your email address and order number. The merchant uses these details to manually identify your order.',
    'Nom': 'Name',
    'Numéro de commande': 'Order number',
    'E-mail': 'Email',
    'Champ obligatoire. Entrez le numéro de commande comme indiqué dans votre confirmation.': 'Required field. Please enter the order number exactly as shown in your confirmation.',
    'Votre confirmation sera envoyée à cette adresse.': 'You will receive the confirmation at this address.',
    'Entreprise': 'Company',
    'Notre': 'Our',
    'politique de confidentialité': 'privacy policy',
    's’applique.': 'applies.',
    'Continuer': 'Continue',
    'Vérification en cours…': 'Checking order...',
    'Sélectionné:': 'Selected:',
    'Aucun article de cette commande ne peut être rétracté via ce formulaire, car tous les articles sont exclus du droit de rétractation (voir les informations sur le droit de rétractation). Veuillez contacter le marchand en cas de questions.': 'No items from this order can be withdrawn through this form because all items are excluded from withdrawal (see withdrawal policy). Please contact the merchant if you have any questions.',
    'Motif (optionnel)': 'Reason (optional)',
    'Aucune indication': 'No reason given',
    'Message (optionnel)': 'Message (optional)',
    'Articles (optionnel)': 'Items (optional)',
    'Aucun article trouvé pour cette commande.': 'No items found for this order.',
    'Retour': 'Back',
    'Confirmer la rétractation': 'Confirm withdrawal',
    'Envoi en cours…': 'Sending...',
    'Rétractation reçue': 'Withdrawal received',
    'Référence:': 'Reference:',
    'Une confirmation a été envoyée à': 'A confirmation has been sent to',
    'Vérifier également le dossier spam.': 'Please also check your spam folder.'
  };
  var placeholderMap = {
    'Optionnel : votre nom': 'Your name',
    'nom@exemple.fr': 'name@example.com'
  };

  function replaceTextNode(node){
    var original = (node.nodeValue || '').replace(/\s+/g, ' ').trim();
    if (textMap[original]) node.nodeValue = node.nodeValue.replace(original, textMap[original]);
  }
  function translate(root){
    if (!root) return;
    root.querySelectorAll('input, textarea').forEach(function(el){
      var p = el.getAttribute('placeholder');
      if (placeholderMap[p]) el.setAttribute('placeholder', placeholderMap[p]);
      var aria = el.getAttribute('aria-label');
      if (textMap[aria]) el.setAttribute('aria-label', textMap[aria]);
    });
    root.querySelectorAll('*').forEach(function(el){
      ['title','aria-label'].forEach(function(a){ var v=el.getAttribute(a); if(textMap[v]) el.setAttribute(a,textMap[v]); });
    });
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n; while ((n = walker.nextNode())) replaceTextNode(n);
  }
  function run(){
    var host = document.querySelector('[data-widerruf-inline]');
    var root = host && host.shadowRoot;
    if (!root) return false;
    translate(root);
    if (!root.__marcheLinoWithdrawalEnglishObserver) {
      root.__marcheLinoWithdrawalEnglishObserver = new MutationObserver(function(){
        window.clearTimeout(root.__marcheLinoWithdrawalEnglishTimer);
        root.__marcheLinoWithdrawalEnglishTimer = window.setTimeout(function(){ translate(root); }, 50);
      });
      root.__marcheLinoWithdrawalEnglishObserver.observe(root, {childList:true, subtree:true});
    }
    return true;
  }
  var tries = 0;
  var timer = setInterval(function(){ if (run() || ++tries > 60) clearInterval(timer); }, 250);
  document.addEventListener('DOMContentLoaded', run);
})();
/* /marche-lino-withdrawal-form-english-v1 */
